import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { useThemeStore } from '@shared/hooks/useThemeStore';
import IconButtonTooltip from './IconButtonTooltip';

/** Light/dark mode toggle button for the TopBar. */
export default function ThemeModeToggle() {
  const mode = useThemeStore((s) => s.mode);
  const toggleMode = useThemeStore((s) => s.toggleMode);

  return (
    <IconButtonTooltip
      title={mode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
      onClick={toggleMode}
      size="small"
    >
      {mode === 'light' ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
    </IconButtonTooltip>
  );
}
